// Client-side User-Agent detection for the onboarding handoff.
//
// Mirrors the server classifier (src/shared/user-agent/ua-classify.js): the
// server stamps every web-event for analytics, while these run in the SPA to
// adapt the handoff UX live — chiefly to surface an "open in Safari/Chrome"
// hint when the sms: deep link fails inside a Facebook/Instagram webview.
//
// Best-effort markers, not a full UA parser. SSR-safe (guards `navigator`).

function ua(): string {
  return typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
}

// True for the in-app browsers that dominate paid-social traffic, where the
// sms: scheme is most likely to be blocked or no-op.
export function isInAppWebview(): boolean {
  const s = ua();
  if (!s) return false;
  return /\bFBAN\b|\bFBAV\b|FB_IAB|FB4A|FBIOS|Instagram|BytedanceWebview|musical_ly|\bTikTok\b|Aweme|Snapchat|MicroMessenger|\bLine\/|; wv\)/i.test(s);
}

export type OsFamily = 'ios' | 'android' | 'mac' | 'other';

export function getOs(): OsFamily {
  const s = ua();
  if (/iPhone|iPad|iPod/i.test(s)) return 'ios';
  if (/Android/i.test(s)) return 'android';
  // macOS is its own family because, unlike Windows/Linux, a Mac paired with
  // an iPhone (Continuity / Text Message Forwarding) DOES launch Messages.app
  // from an sms: link — so the handoff should fire the deep link + watch,
  // not short-circuit straight to the copyable fallback. (iPadOS desktop-mode
  // Safari reports as Macintosh too; it can open Messages, so 'mac' fits there.)
  if (/Macintosh|Mac OS X/i.test(s)) return 'mac';
  return 'other';
}
